import { RolesEnum } from 'infrastructure/enums/RolesEnum';
import * as CS from 'view/pages/profile/commonStyled';
import { useContextSelector as useCS } from 'use-context-selector';
import { GlobalConfigContext } from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import JobSeekerPreferences from './JobSeekerPreferences';
import RecruiterPreferences from './RecruiterPreferences';

const WorkPreferences = () => {
  const {
    role: { name: roleName },
  } = useCS(GlobalConfigContext, globalConfigSelectors.userData);

  return (
    <CS.ProfileMainWrapper>
      <CS.FormWrapper>
        {roleName === RolesEnum.RECRUITER ? <RecruiterPreferences /> : <JobSeekerPreferences />}
      </CS.FormWrapper>
    </CS.ProfileMainWrapper>
  );
};

export default WorkPreferences;
